import { render, staticRenderFns } from "./RecallModal.vue?vue&type=template&id=2baa02ca&"
import script from "./RecallModal.vue?vue&type=script&lang=js&"
export * from "./RecallModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports